import React from "react";
import NomesComponent from "./components/Nomes";

const Nomes = () => {
  return <NomesComponent />;
};

export default Nomes;